import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './app-card.html',
  styles: ``
})
export class AppCard {
  @Input() padding: 'none' | 'sm' | 'md' | 'lg' = 'md';
  @Input() glass = false;
  @Input() animate = true;

  // Metric & Stat supports
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() value: string | number = '';
  @Input() icon: string = '';
  @Input() iconPosition: "start" | "top" = "start";
  @Input() iconClass: string = '';

  get classes(): string {
    const paddings = {
      none: '',
      sm: 'p-4',
      md: 'p-6',
      lg: 'p-8',
    };

    return `bg-white dark:bg-slate-900 border border-foreground/[0.04] rounded-xl shadow-premium relative overflow-hidden ${paddings[this.padding]} ${this.glass ? 'glass' : ''} ${this.animate ? 'animate-fade-in' : ''}`;
  }
}
